import React, { useState } from 'react';
import { ThemeProvider as _ThemeProvider } from 'styled-components';
import { Themes, Theme, ThemeStorageKey, HorizonTheme } from 'utils/color/horizonTheme';
import { getItem as getStorageItem, setItem as setStorageItem } from 'utils/storage';

export const ThemeProvider: React.FC<{ theme: Omit<HorizonTheme, 'onChange'> }> = ({
  children,
  ...props
}) => {
  const [currentTheme, setCurrentTheme] = useState<Omit<HorizonTheme, 'onChange'>>(
    Themes[(getStorageItem(ThemeStorageKey) ?? Theme.Light) as Theme]
  );

  const handleChange = (themeName: Theme) => {
    setCurrentTheme(Themes[themeName]);
    setStorageItem(ThemeStorageKey, themeName);
  };

  return (
    <_ThemeProvider
      {...props}
      theme={{
        ...currentTheme,
        onChange: handleChange,
      }}
    >
      {children}
    </_ThemeProvider>
  );
};
